<template>
    <div class="n2-center-container">
        <div style="margin:20px;">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{$t('pages.account.order.back')}}
                    </span>
                </div>
            </a>
        </div>
        <div style="background:#fff; padding:20px;">
            <div v-html="order_html"></div>
        </div>
        <app-loader v-bind:active="loading"></app-loader>

    </div>
</template>

<script>
    /*import { mapGetters } from 'vuex';*/

    import { OrderService } from '../services'
    import AppLoader from '../components/shared/loader.vue'

    export default {
        components: {
            AppLoader
        },
        data: function () {
            return {
                order: {},
                order_html: '',
                loading: false
            }
        },
        created: function () {
            this.orderService = new OrderService()
        },
        mounted: async function () {
            const { id } = this.$route.params;
            const orderToken = this.$route.query.order_token;
            this.order = await this.orderService.find(id, orderToken);
            const effectiveToken = this.order?.token || orderToken;
            this.order_html = await this.orderService.getHtml(this.order.id, this.order.template, effectiveToken)

        },
        methods: {
        }
    }
</script>
